__turbopack_context__.v({
  "circle": "CoreServicesListingTabs-module-scss-module__FlhMvW__circle",
  "left-column": "CoreServicesListingTabs-module-scss-module__FlhMvW__left-column",
  "list": "CoreServicesListingTabs-module-scss-module__FlhMvW__list",
  "main": "CoreServicesListingTabs-module-scss-module__FlhMvW__main",
  "tabs-list-wrapper": "CoreServicesListingTabs-module-scss-module__FlhMvW__tabs-list-wrapper",
  "trigger": "CoreServicesListingTabs-module-scss-module__FlhMvW__trigger",
});
